<template>
  <div class="row">
    <div class="col-12 col-md-4">
      <div class="card my-3 border-0 shadow-sm border-top">
        <div class="card-body">
          <p class="mb-3 fw-bold text-black-50">
            <i class="fa-solid fa-calendar-alt fa-fw text-primary"></i>
            This Week Income
          </p>
          <div class="">
            <PolarChart></PolarChart>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="card my-3 border-0 shadow-sm border-top">
        <div class="card-body">
          <p class="mb-3 fw-bold text-black-50">
            <i class="fa-solid fa-calendar-alt fa-fw text-success"></i>
            This Year Income
          </p>
          <CircularChart></CircularChart>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="card my-3 border-0 shadow-sm border-top">
        <div class="card-body">
          <p class="mb-3 fw-bold text-black-50">
            <i class="fa-solid fa-calendar-alt fa-fw text-success"></i>
            This Year Income
          </p>
          <Monochrome></Monochrome>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PolarChart from "@/components/chart/PolarChart";
import CircularChart from "@/components/chart/CircularChart";
import Monochrome from "@/components/chart/Monochrome";
export default {
  name: "DataAnalysis",
  components: {Monochrome, CircularChart, PolarChart}
}
</script>

<style scoped>
.card{
  height: 350px;
}
</style>